import Swiper from '../../../../_base/src/components/swiper'

export default class ElfordSwiperCarousel extends Swiper {
	static title = 'block-gallery__inner-swiper'

	setter() {
		this.speed = 400
		this.slideReset = 2
	}
}
